module.exports = __webpack_public_path__ + "static/media/CZ.072878bc.svg";